import axios from 'axios'

export const getConfiguration = async () => {
  return await axios.get('/api/configuration/azure')
}